var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photo-wrapper"},[_c('ContentGeneratorElementsMedia',{attrs:{"value":_vm.content,"size-image":"w2000","aspect-ratio":_vm.aspectRatio,"aspect-ratio-mobile":_vm.aspectRatioMobile,"is-no-border-radius":_vm.isNoBorderRadius}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }